import { getIdAndEmitterTypeFromZoneEmitterTypeKey } from 'App/Map/_utils/irrigationZoneEmitterTypeKeyUtil'
import type { TValuesTimeseriesIrrigationZones } from 'App/Map/types'
import type { TIrrigationZoneEmitterId, TProperty } from 'stores/fieldAssetStore/helperTypes'

type TIrrigationZonesBody = {
  irrigationZoneIds: number[]
  valuesRequested: Record<string, { preferredAggregationInterval: string }>
}

export const getIrrigationZonesBody = (options: {
  irrigationZoneEmitterIds: string[]
  interval: string
  property: TProperty
  valueTypes: string[]
}): TIrrigationZonesBody => {
  const { irrigationZoneEmitterIds, interval, property, valueTypes } = options

  return irrigationZoneEmitterIds.reduce<TIrrigationZonesBody>(
    (irrigationZonesBody, zoneEmitterId) => {
      const irrigationZoneEmitterId = zoneEmitterId as TIrrigationZoneEmitterId
      const irrigationZoneEmitter = property?.irrigationZoneEmitters?.[irrigationZoneEmitterId]

      if (!irrigationZoneEmitter?.valuesTimeseries) {
        return irrigationZonesBody
      }

      let includeIrrigationZone = false

      valueTypes.forEach((valueType) => {
        if (irrigationZoneEmitter.valuesTimeseries.includes(valueType as TValuesTimeseriesIrrigationZones)) {
          includeIrrigationZone = true

          if (!irrigationZonesBody.valuesRequested[valueType]) {
            irrigationZonesBody.valuesRequested[valueType] = { preferredAggregationInterval: interval }
          }
        }
      })

      if (includeIrrigationZone) {
        const irrigationZoneId = Number(
          getIdAndEmitterTypeFromZoneEmitterTypeKey(irrigationZoneEmitterId).irrigationZoneId,
        )

        if (!irrigationZonesBody.irrigationZoneIds.includes(irrigationZoneId)) {
          irrigationZonesBody.irrigationZoneIds.push(irrigationZoneId)
        }
      }

      return irrigationZonesBody
    },
    { irrigationZoneIds: [], valuesRequested: {} },
  )
}
